// extracted by mini-css-extract-plugin
export default {"subheader":"ListDivider_subheader__dG5LZ","button":"ListDivider_button__FSRgU"};